import { gql } from '@apollo/client';

export default gql`
  query NestedFieldTypesQuery(
    $field: String!
    $schemaId: ID!
    $context: FieldContext!
    $func: String
    $events: [EventInput!]!
    $term: String
    $includeValues: [String!]!
  ) {
    nestedField(
      field: $field
      schemaId: $schemaId
      func: $func
      context: $context
      events: $events
      term: $term
      includeValues: $includeValues
    ) {
      types
    }
  }
`;
